module.exports = __webpack_public_path__ + "img/topxywl_bg.7e16a5a4.png";